import { FolderId } from 'modules/domains/foldering';
import * as t from './actionTypes';

export const copyCampaignRequest = (
  campaignId: number,
  destinationFolderId: FolderId | null,
  refetch: () => void,
) => ({
  type: t.COPY_CAMPAIGN_REQUEST,
  campaignId,
  destinationFolderId,
  refetch,
});

export const copyCampaignResponse = () => ({ type: t.COPY_CAMPAIGN_RESPONSE });

export const archiveCampaignsRequest = (campaignIds: number[], refetch: () => void) => ({
  type: t.ARCHIVE_CAMPAIGNS_REQUEST,
  campaignIds,
  refetch,
});

export const archiveCampaignsResponse = () => ({ type: t.ARCHIVE_CAMPAIGNS_RESPONSE });

export const unarchiveCampaignsRequest = (campaignIds: number[], refetch: () => void) => ({
  type: t.UNARCHIVE_CAMPAIGNS_REQUEST,
  campaignIds,
  refetch,
});

export const unarchiveCampaignsResponse = () => ({ type: t.UNARCHIVE_CAMPAIGNS_RESPONSE });

export const exportCampaignToCSV = (campaignIds: number[], projectName: string) => ({
  type: t.EXPORT_CAMPAIGN_TO_CSV_REQUEST,
  campaignIds,
  projectName,
});

export const exportCampaignToCSVResponse = () => ({ type: t.EXPORT_CAMPAIGN_TO_CSV_RESPONSE });

export const getCampaignMetricsRequest = (campaignIds: number[]) => ({
  type: t.GET_CAMPAIGN_METRICS_REQUEST,
  campaignIds,
});

export const getCampaignMetricsResponse = (campaignMetrics: Record<string, unknown> = {}) => ({
  type: t.GET_CAMPAIGN_METRICS_RESPONSE,
  campaignMetrics,
});
